import { render, staticRenderFns } from "./league-detail.vue?vue&type=template&id=e2133894&"
import script from "./league-detail.vue?vue&type=script&lang=js&"
export * from "./league-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports